/* Native details keep every navigation link usable without JavaScript. */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const prepare = (root = document) => {
    root.querySelectorAll('[data-solid-mobile-disclosure]').forEach(details => {
      if (details.dataset.mobileReady) return;
      details.dataset.mobileReady = 'true';
      details.open = !mobile.matches;
    });
  };
  const policy = document.querySelector('.solid-reading-page .shopify-policy__container');
  const headings = policy ? [...policy.querySelectorAll('.shopify-policy__body h2')] : [];
  if (headings.length > 3) {
    const toc = document.createElement('details');
    toc.className = 'solid-mobile-disclosure solid-reading-toc';
    const summary = document.createElement('summary');
    summary.textContent = 'Op deze pagina';
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Onderwerpen op deze pagina');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `solid-policy-topic-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      nav.append(link);
    });
    toc.append(summary, nav);
    policy.querySelector('.shopify-policy__title')?.after(toc);
  }
  prepare();
  mobile.addEventListener('change', () => {
    document.querySelectorAll('[data-solid-mobile-disclosure]').forEach(details => {
      details.open = !mobile.matches;
    });
  });
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
